import { createStore, createEvent } from 'effector';

export const $unreadAnnouncementsCount = createStore(0);

export const setUnreadAnnouncementsCount = createEvent();

$unreadAnnouncementsCount
    .on(setUnreadAnnouncementsCount, (_, value) => value);